import GeneralSettings from '@/services/generalSettings'
import * as types from './mutation-types'

export const loadGeneralSettings = async ({ commit, state }, filters) => { 
  if (state.cache.generalSettingsLoaded) {
    return state.generalSettings
  }
  const response = await GeneralSettings.listWalletHistoric(filters)
  const generalSettings = response?.settings[0] || {}
  
  commit(types.SET_GENERAL_SETTINGS, { generalSettings })
  return generalSettings
}